// Powerful motivational quotes for athletes
export const MOTIVATIONAL_QUOTES = [
  {
    quote: "The only way to prove that you're a good sport is to lose.",
    author: "Ernie Banks"
  },
  {
    quote: "Champions keep playing until they get it right.",
    author: "Billie Jean King"
  },
  {
    quote: "You miss 100% of the shots you don't take.",
    author: "Wayne Gretzky"
  },
  {
    quote: "Hard work beats talent when talent doesn't work hard.",
    author: "Tim Notke"
  },
  {
    quote: "The difference between the impossible and the possible lies in a person's determination.",
    author: "Tommy Lasorda"
  },
  {
    quote: "It's not whether you get knocked down, it's whether you get up.",
    author: "Vince Lombardi"
  },
  {
    quote: "The only person you should try to be better than is the person you were yesterday.",
    author: "Anonymous"
  },
  {
    quote: "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing.",
    author: "Pelé"
  },
  {
    quote: "Never let the fear of striking out keep you from playing the game.",
    author: "Babe Ruth"
  },
  {
    quote: "You can't put a limit on anything. The more you dream, the farther you get.",
    author: "Michael Phelps"
  },
  {
    quote: "I've failed over and over and over again in my life. And that is why I succeed.",
    author: "Michael Jordan"
  },
  {
    quote: "The more difficult the victory, the greater the happiness in winning.",
    author: "Pelé"
  },
  {
    quote: "If you can't outplay them, outwork them.",
    author: "Ben Hogan"
  },
  {
    quote: "Do you know what my favorite part of the game is? The opportunity to play.",
    author: "Mike Singletary"
  },
  {
    quote: "Winners never quit and quitters never win.",
    author: "Vince Lombardi"
  },
  {
    quote: "It's hard to beat a person who never gives up.",
    author: "Babe Ruth"
  },
  {
    quote: "You're never a loser until you quit trying.",
    author: "Mike Ditka"
  },
  {
    quote: "I hated every minute of training, but I said, 'Don't quit. Suffer now and live the rest of your life as a champion.'",
    author: "Muhammad Ali"
  },
  {
    quote: "What makes something special is not just what you have to gain, but what you feel there is to lose.",
    author: "Andre Agassi"
  },
  {
    quote: "Persistence can change failure into extraordinary achievement.",
    author: "Matt Biondi"
  },
  {
    quote: "It's not the will to win that matters—everyone has that. It's the will to prepare to win that matters.",
    author: "Paul Bryant"
  },
  {
    quote: "The principle is competing against yourself. It's about self-improvement, about being better than you were the day before.",
    author: "Steve Young"
  },
  {
    quote: "Gold medals aren't really made of gold. They're made of sweat, determination, and a hard-to-find alloy called guts.",
    author: "Dan Gable"
  },
  {
    quote: "Most people give up just when they're about to achieve success. They quit on the one yard line.",
    author: "Ross Perot"
  },
  {
    quote: "An athlete cannot run with money in his pockets. He must run with hope in his heart and dreams in his head.",
    author: "Emil Zátopek"
  },
  {
    quote: "Make sure your worst enemy doesn't live between your own two ears.",
    author: "Laird Hamilton"
  },
  {
    quote: "The fight is won or lost far away from witnesses—behind the lines, in the gym, and out there on the road, long before I dance under those lights.",
    author: "Muhammad Ali"
  },
  {
    quote: "Age is no barrier. It's a limitation you put on your mind.",
    author: "Jackie Joyner-Kersee"
  },
  {
    quote: "If you don't have confidence, you'll always find a way not to win.",
    author: "Carl Lewis"
  },
  {
    quote: "A champion is someone who gets up when they can't.",
    author: "Jack Dempsey"
  },
  {
    quote: "The only way to prove you are a good sport is to lose.",
    author: "Ernie Banks"
  },
  {
    quote: "Talent wins games, but teamwork and intelligence win championships.",
    author: "Michael Jordan"
  },
  {
    quote: "The hardest skill to acquire in this sport is the one where you compete all out, give it all you have, and you are still getting beat no matter what you do.",
    author: "Eddie Reese"
  },
  {
    quote: "You have to expect things of yourself before you can do them.",
    author: "Michael Jordan"
  },
  {
    quote: "Somewhere behind the athlete you've become and the hours of practice and the coaches who have pushed you is a little girl who fell in love with the game and never looked back... play for her.",
    author: "Mia Hamm"
  },
  {
    quote: "The road to Easy Street goes through the sewer.",
    author: "John Madden"
  },
  {
    quote: "It ain't over till it's over.",
    author: "Yogi Berra"
  },
  {
    quote: "If you aren't going all the way, why go at all?",
    author: "Joe Namath"
  },
  {
    quote: "Winning isn't everything, but wanting to win is.",
    author: "Vince Lombardi"
  },
  {
    quote: "I've missed more than 9,000 shots in my career. I've lost almost 300 games. 26 times I've been trusted to take the game winning shot and missed. I've failed over and over and over again in my life. And that is why I succeed.",
    author: "Michael Jordan"
  },
  {
    quote: "The only one who can tell you 'you can't win' is you and you don't have to listen.",
    author: "Jessica Ennis-Hill"
  },
  {
    quote: "If you have everything under control, you're not moving fast enough.",
    author: "Mario Andretti"
  },
  {
    quote: "Don't measure yourself by what you have accomplished, but by what you should have accomplished with your ability.",
    author: "John Wooden"
  },
  {
    quote: "Just keep going. Everybody gets better if they keep at it.",
    author: "Ted Williams"
  },
  {
    quote: "You were born to be a player. You were meant to be here. This moment is yours.",
    author: "Herb Brooks"
  },
  {
    quote: "The mind is the limit. As long as the mind can envision the fact that you can do something, you can do it, as long as you really believe 100 percent.",
    author: "Arnold Schwarzenegger"
  },
  {
    quote: "When you've got something to prove, there's nothing greater than a challenge.",
    author: "Terry Bradshaw"
  },
  {
    quote: "Good is not good when better is expected.",
    author: "Vin Scully"
  },
  {
    quote: "To uncover your true potential you must first find your own limits and then you have to have the courage to blow past them.",
    author: "Picabo Street"
  }
];

// Get a random quote
export const getRandomQuote = () => {
  const randomIndex = Math.floor(Math.random() * MOTIVATIONAL_QUOTES.length);
  return MOTIVATIONAL_QUOTES[randomIndex];
};

// Get quote of the day (same quote for the entire day)
export const getQuoteOfTheDay = () => {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
  const index = dayOfYear % MOTIVATIONAL_QUOTES.length;
  return MOTIVATIONAL_QUOTES[index];
};